import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { AppConstant } from '../class/app-constant';



@Directive({
  selector: '[imageLoad]'
})
export class ImageLoadDirective {
  @Input('imageLoad') public imgType: string | any;
  //@Input('imageLoad') public errorOnhide: boolean=false;
  constructor(private renderer: Renderer2,
    private el: ElementRef) {
    this.el.nativeElement.classList.add('loading');
  }

  @HostListener('load') onLoad() {
    this.el.nativeElement.classList.remove('loading');
  }
  @HostListener('onImageError') onImageError() {
    this.imageReplace(this.el.nativeElement.getElementsByTagName('img')[0]);
    console.log('onImageError', this.renderer, this.el.nativeElement.getElementsByTagName('img')[0])
  }

  @HostListener('error') onError() {
    this.imageReplace();
  }
  imageReplace(element: any = this.el.nativeElement) {
    const src = this.imgType == 'group' ? AppConstant.DEFAULT_GROUP_IMAGE_URL : AppConstant.DEFAULT_PROFILE_IMAGE;
    if (element.getAttribute('src') !== src) {
      this.renderer.setAttribute(element, 'src', src);
    }
    this.el.nativeElement.classList.remove('loading');
  }
}
